import { createBrowserRouter } from "react-router";

import { appRoutes } from "@/src/routes/appRoutes";

/**
 * Routeur de l'application.
 *
 * Créé au chargement du module, hors de React : c'est ce qu'attend
 * `RouterProvider`, et ça évite de reconstruire l'historique à chaque render.
 *
 * ⚠️ Les URL sont de vrais chemins (`/sign-in`), pas des fragments : le serveur
 * qui sert le bundle **doit** rabattre toute route inconnue sur `index.html`,
 * sinon un rechargement sur `/sign-in` renvoie un 404. C'est fait côté nginx
 * (`docker/nginx.conf`) et Vite s'en charge en développement.
 */
export const router = createBrowserRouter(appRoutes);
